(function() {
  'use strict';

  var script = document.currentScript;
  var eligible = Boolean(script && script.getAttribute('data-lab-diamond-offer') === 'true');
  var pageKey = window.location.pathname + window.location.search;
  var previousState = window.__amourProofFactorLabDiamondOffer;

  if (previousState && previousState.pageKey === pageKey && previousState.initialized) {
    return;
  }

  if (previousState && previousState.observer) {
    previousState.observer.disconnect();
  }

  var state = {
    eligible: eligible,
    initialized: true,
    observer: null,
    pageKey: pageKey
  };

  window.__amourProofFactorLabDiamondOffer = state;

  function couponApp() {
    return document.getElementById('proof-factor-app');
  }

  function suppressIneligibleWidget() {
    var app = couponApp();

    if (!app) {
      return;
    }

    app.setAttribute('aria-hidden', 'true');
    app.setAttribute('data-ad-proof-factor-suppressed', 'true');

    if (
      app.style.getPropertyValue('display') !== 'none' ||
      app.style.getPropertyPriority('display') !== 'important'
    ) {
      app.style.setProperty('display', 'none', 'important');
    }
  }

  if (!eligible) {
    suppressIneligibleWidget();

    window.addEventListener('prooffactor:widget:loaded', suppressIneligibleWidget);

    if (window.MutationObserver) {
      state.observer = new MutationObserver(suppressIneligibleWidget);
      state.observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style']
      });
    }

    window.setTimeout(suppressIneligibleWidget, 500);
    window.setTimeout(suppressIneligibleWidget, 2500);
    return;
  }

  document.documentElement.setAttribute('data-proof-factor-display-control', 'native');
})();
